import { render, staticRenderFns } from "./PollCompanyInputForm.vue?vue&type=template&id=84fc2c16&scoped=true&"
import script from "./PollCompanyInputForm.vue?vue&type=script&lang=js&"
export * from "./PollCompanyInputForm.vue?vue&type=script&lang=js&"
import style0 from "./PollCompanyInputForm.vue?vue&type=style&index=0&id=84fc2c16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fc2c16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
